import { View } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../Event/PhaseChangeEvent";

export class IframeView extends View {
    iframeSrc:string;
    addLanguage:boolean;
    addStyle:boolean;
    addClientId:boolean;
    useOddsIframeUrl:boolean; // from instances instead of screen setup. Will overwrite the iframeSrc
    lastEvent: any;
    name: string;


    constructor(options) {
        options = options || {};
        super(options);

        this.lastEvent = null;
        this.iframeSrc = options.src || '';
        this.addLanguage = options.addLanguage || false;
        this.addStyle = options.addStyle || false;
        this.addClientId = options.addClientId || false;
        this.useOddsIframeUrl = options.useOddsIframeUrl || false;

        this.name =  this.$domNode.attr('id');
        this.$domNode.attr('name', this.name);

        var that = this;
        var postMessageReceiveClosure = function(data){
            that.postMessageReceive(data, that.name);
        };

        window.addEventListener("message", postMessageReceiveClosure, false);
    }


    handleDomInstantiated() {
        this.setIframeSrc(this.iframeSrc);
        super.handleDomInstantiated();
    }

    setOptions(options:any, fromConstructor?:boolean) {

        var oldIFrameSrc = "";
        if (options.src && this.iframeSrc != options.src) {
            oldIFrameSrc = this.iframeSrc;
            this.iframeSrc = options.src;
        }

        if(options.useOddsIframeUrl && srvg.url.shopOddsIframeUrl != ''){
            this.iframeSrc = srvg.url.shopOddsIframeUrl;
        }

        if (options.addStyle) {
            this.setAddStyle(options.addStyle);
        }
        if (options.addLanguage) {
            this.setAddLanguage(options.addLanguage);
        }
        if (options.addClientId) {
            this.setAddClientId(options.addClientId);
        }


        if (oldIFrameSrc !== this.iframeSrc){
            this.setIframeSrc(this.iframeSrc);
        }
        super.setOptions(options, fromConstructor);
    }

    setIframeSrc(src) {
        this.iframeSrc = src;
        if (this.$domNode) {
            if (this.$domNode.attr('src') !== this.iframeSrc){
                this.$domNode.attr('src', this.iframeSrc);
                //send Message again
                this.sendMessageToContentWindow();
            }
        }
    }

    setAddStyle(addStyle:boolean) {
        if (addStyle) {
            this.addGetParam("style", srvg.customer.style);
        } else {
            this.removeGetParam("style");
        }
    }

    setAddLanguage(addLanguage:boolean) {
        if (addLanguage) {
            this.addGetParam("lang", srvg.customer.language);
        } else {
            this.removeGetParam("lang");
        }
    }

    setAddClientId(addClientId:boolean) {
        if (addClientId) {
            this.addGetParam("clientid", srvg.customer.clientId);
        } else {
            this.removeGetParam("clientid");
        }
    }

    private addGetParam(paramName:string, paramValue:any) {

        // remove parameter before adding it
        this.iframeSrc = this.removeGetParamFromUrl(this.iframeSrc, "paramName");

        // find position in url to add. Important before "#"
        let addPosition = 0;
        let findPosition = this.iframeSrc.indexOf("#");
        if(findPosition !== -1){
            addPosition = findPosition;
        }else{
            addPosition = this.iframeSrc.length;
        }

        let insert = paramName + '=' + paramValue;

        if (this.iframeSrc.indexOf("?") !== -1){
            // add parameter with  & if "?" is already set in url
            insert = '&' + insert;
        }else{
            // add parameter with ? if no ? is in url
            insert = '?' + insert;
        }

        // set url
        this.iframeSrc = this.iframeSrc.substr(0, addPosition) + insert + this.iframeSrc.substr(addPosition);
    }

    private removeGetParam(paramName:string) {
        this.setIframeSrc(
            this.removeGetParamFromUrl(this.iframeSrc, paramName)
        );
    }

    private removeGetParamFromUrl(url, paramName){
        return this.iframeSrc
            .replace(new RegExp('[?&]' + paramName + '=[^&#]*(#.*)?$'), '$1')
            .replace(new RegExp('([?&])' + paramName + '=[^&]*&'), '$1');
    }

    handlePhaseChangeEvent(event:PhaseChangeEvent, provider) {
        this.lastEvent = event;
        this.sendMessageToContentWindow();
    }

    sendMessageToContentWindow(){

        var that = this;
        var event = this.lastEvent;
        if (!event){
            return;
        }
        let now = app.server.getTime();
        let objectNode = {
            setVfStatus: {
                servertime: now,
                current: {
                    chunk_nr: event.chunk.nr,
                    matchset_nr: event.chunk.matches[0].matchset.nr,
                    competition_stage_nr: event.chunk.matches[0].matchset.competitionStage.nr,
                    season_nr: event.chunk.competition.nr,
                    round: event.chunk.round(),
                    round_part: event.chunk.roundPart()
                },
                period: event.phase.name,
                cycle: event.phase.cycle(),
                countdown: event.phase.end - now,
                screen_variant: srvg.product.name
            }
        };

        that.$domNode[0].contentWindow.postMessage(JSON.stringify(objectNode), '*');
    }

    postMessageReceive(data:any, name:string){
        let message = data.data;
        if (message === this.name){
            this.sendMessageToContentWindow();
        }
    }

}